"use client";
import b from "styled-components";
import e, { useMemo as o } from "react";
import "./index.es73.js";
import "./index.es74.js";
import "./index.es75.js";
import "./index.es76.js";
import "./index.es77.js";
import "./index.es78.js";
import "./index.es79.js";
import "./index.es80.js";
import "./index.es81.js";
import "./index.es83.js";
import "./index.es84.js";
import "./index.es85.js";
import "./index.es86.js";
import "./index.es87.js";
import "./index.es88.js";
import "./index.es89.js";
import "./index.es90.js";
import "./index.es91.js";
import { createChartOptions as C } from "./index.es275.js";
import "./index.es92.js";
import "./index.es93.js";
import "./index.es94.js";
import "./index.es95.js";
import "./index.es96.js";
import { updateChartOptionVariablesByType as M, getChartFileNameFromSettingsAndBlockId as k, getExcelFileNameFromSettingsAndBlockId as v } from "./index.es97.js";
import D from "./index.es276.js";
import I from "./index.es277.js";
import N from "./index.es278.js";
import B from "./index.es279.js";
import S from "./index.es280.js";
const q = b.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
`, A = b.div`
  position: relative;
`, R = b.div`
  display: flex;
  flex-wrap: wrap;

  & > * {
    margin-right: 1rem;
    margin-bottom: 0.5rem;
  }
`, ge = ({
  chartData: i,
  settings: t,
  rules: l,
  blockId: a,
  currentUnits: f,
  chartOptionVariablesByType: g,
  statisticsChartOptions: m,
  annotations: h,
  content: E,
  file: y,
  title: d,
  dimensionLabels: F,
  onSettingsChange: L
}) => {
  const c = o(() => {
    const { primary: r } = t, s = ["bar", "table"];
    return r && !l.singlePrimaryFilterDefaults?.[r] && l.dimensionFlags?.[r]?.isSequential && s.unshift("line"), s;
  }, [l, t.primary]), n = o(() => {
    if (t.isTableMode)
      return "table";
    const r = t.primary;
    return t.isLineChart && l.dimensionFlags?.[r]?.isSequential && c.includes("line") ? "line" : "bar";
  }, [t.isTableMode, t.isLineChart, l, c]), x = o(
    () => n === "line" ? "line" : "bar",
    [n]
  ), O = (r) => {
    const s = { ...t, isLineChart: r === "line", isTableMode: r === "table" };
    L(s);
  }, p = o(
    () => M(
      g,
      m,
      n,
      i,
      h
    ),
    [
      n,
      m,
      g,
      i,
      h
    ]
  ), w = o(() => ({
    screen: C(p.screen),
    download: C(p.download)
  }), [p]), T = m.disableDownloadOriginalExcel ? "Last ned Excel" : "Last ned Excel (filtrert)", u = `Med statistikk om ${d}`;
  return /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(q, null, /* @__PURE__ */ e.createElement(
    S,
    {
      blockId: a,
      viewMode: n,
      viewModeChoices: c,
      onChange: O
    }
  )), /* @__PURE__ */ e.createElement(A, null, /* @__PURE__ */ e.createElement(
    B,
    {
      blockId: a,
      chartData: i,
      chartOptions: w,
      currentUnits: f,
      viewMode: n,
      title: d
    }
  )), E && /* @__PURE__ */ e.createElement(
    N,
    {
      parentId: a,
      content: E,
      settings: t
    }
  ), /* @__PURE__ */ e.createElement(R, { className: "bl-container bl-container--small" }, y.url && !m.disableDownloadOriginalExcel && /* @__PURE__ */ e.createElement(
    "a",
    {
      href: y.url,
      className: "bl-button bl-button--primary bl-button--medium"
    },
    "Last ned Excel (all data)",
    /* @__PURE__ */ e.createElement("span", { className: "bl-sr-only" }, u),
    /* @__PURE__ */ e.createElement("i", { "aria-hidden": "true", className: "bl-icon--download" })
  ), i && /* @__PURE__ */ e.createElement(e.Fragment, null, /* @__PURE__ */ e.createElement(
    D,
    {
      data: i,
      type: x,
      options: w.download,
      filename: k(
        t,
        a
      ),
      dataId: `${a}-${x}`,
      screenReaderText: u
    }
  ), /* @__PURE__ */ e.createElement(
    I,
    {
      chartdata: i,
      isDecimal: f !== "Amount",
      filename: v(
        t,
        a
      ),
      settings: t,
      title: d,
      dimensionLabels: F,
      buttonText: T,
      screenReaderText: u
    }
  ))));
};
export {
  ge as default
};
//# sourceMappingURL=index.es175.js.map
